import { render, staticRenderFns } from "./ConfirmDelete3.vue?vue&type=template&id=2bebbef0&"
import script from "./ConfirmDelete3.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports